var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInvite = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.628 17.311a3.45 3.45 0 0 0-2.303.892l-8.38-4.807a3.74 3.74 0 0 0 .106-.811 3.74 3.74 0 0 0-.105-.811l8.285-4.761c.634.579 1.469.938 2.397.938 1.951 0 3.526-1.552 3.526-3.476C23.154 2.552 21.579 1 19.628 1c-1.95 0-3.525 1.552-3.525 3.475 0 .278.047.545.105.811l-8.285 4.762a3.538 3.538 0 0 0-2.397-.939C3.575 9.11 2 10.662 2 12.585s1.575 3.475 3.526 3.475c.928 0 1.762-.359 2.397-.938l8.368 4.82a3.223 3.223 0 0 0-.094.752c0 1.865 1.54 3.383 3.431 3.383 1.892 0 3.432-1.518 3.432-3.383s-1.54-3.383-3.432-3.383Zm0-13.994a1.17 1.17 0 0 1 1.175 1.158 1.17 1.17 0 0 1-1.175 1.159 1.17 1.17 0 0 1-1.175-1.159 1.17 1.17 0 0 1 1.175-1.158ZM5.526 13.743a1.17 1.17 0 0 1-1.176-1.158 1.17 1.17 0 0 1 1.176-1.159A1.17 1.17 0 0 1 6.7 12.585a1.17 1.17 0 0 1-1.175 1.158Zm14.102 8.133a1.17 1.17 0 0 1-1.175-1.159 1.17 1.17 0 0 1 1.175-1.158 1.17 1.17 0 0 1 1.175 1.158 1.17 1.17 0 0 1-1.175 1.159Z"
  })));
};
export { SvgInvite as ReactComponent };